var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkBoxControl",style:({ width: `${_vm.width}px` })},[_c('div',{staticClass:"checkBox"},_vm._l((_vm.selfGruop),function(item,index){return _c('CheckItem',{key:index,attrs:{"color":item.color,"label":item.label,"name":item.name,"checked":item.checked},on:{"setValue":_vm.setValue}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }